// Performance Overview Styles
const performanceContainer = {
  height: '88vh',
  overflow: 'scroll',
  padding: '20px',
  paddingBottom: '100px',
};

const performanceHeadlineContainer = {
  width: '90%',
  textAlign: 'left',
  margin: 'auto',
  fontSize: '1.5rem',
  fontWeight: '500',
  lineHeight: '1.6',
};
const performanceDropdwonContainer = {
  display: 'flex',
  alignItems: 'center',
  width: '90%',
  margin: 'auto',
  justifyContent: 'flex-end',
};

const performanceOppsSummaryCont = {
  width: '90%',
  margin: 'auto',
};
const spendOppsStyle = { width: '80%' };
const oppsSummaryStyle = { width: '55%' };

// Opportunities Insights Styles

const insightsContainer = {
  height: '88vh',
  overflow: 'scroll',
  padding: '20px',
  paddingBottom: '100px',
};

const insightsHeadlineContainer = {
  width: '90%',
  textAlign: 'left',
  margin: 'auto',
  fontSize: '1.5rem',
  fontWeight: '500',
  lineHeight: '1.6',
};
const insightsDropdwonContainer = {
  display: 'flex',
  alignItems: 'center',
  width: '90%',
  margin: 'auto',
  justifyContent: 'flex-end',
};

const insightsOppsSummaryCont = {
  width: '90%',
  margin: 'auto',
};

// common
const branchLoaderStyle = { display: 'flex', justifyContent: 'center' };
const errorContainerStyle = {
  height: '88vh',
  overflow: 'scroll',
  padding: '20px',
  paddingBottom: '100px',
};
const errorTextContainer = {
  width: '90%',
  textAlign: 'left',
  margin: 'auto',
  fontSize: '1.5rem',
  fontWeight: '500',
  lineHeight: '1.6',
};
const errorSubcont = { width: 'fitContent', marginBottom: '55px' };

export default {
  performanceContainer,
  performanceHeadlineContainer,
  performanceDropdwonContainer,
  performanceOppsSummaryCont,
  spendOppsStyle,
  oppsSummaryStyle,
  insightsContainer,
  insightsHeadlineContainer,
  insightsDropdwonContainer,
  insightsOppsSummaryCont,
  branchLoaderStyle,
  errorContainerStyle,
  errorTextContainer,
  errorSubcont,
};
